function AdminLoginSection({ handleLoginSubmit, loginError, loginForm, setLoginForm }) {
  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#f4efe6_0%,#eef3ec_100%)] text-[#183228]">
      <main className="mx-auto flex min-h-screen w-[min(520px,calc(100%-40px))] items-center py-10">
        <section className="w-full rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.92)] p-8 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
          <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Admin</p>
          <h1 className="font-serif text-4xl font-semibold text-[#163127]">Logg inn for a administrere OmsorgBygg.</h1>
          <p className="mt-4 text-[1.05rem] leading-[1.7] text-[#355046]">
            Standardinnlogging er <strong>admin</strong> / <strong>OmsorgBygg123</strong>. Endre dette senere via miljo-variabler pa serveren.
          </p>
          <form className="mt-8 grid gap-4" onSubmit={handleLoginSubmit}>
            <label className="grid gap-2">
              <span className="text-sm font-semibold text-[#355046]">Brukernavn</span>
              <input
                className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
                onChange={(event) => setLoginForm((current) => ({ ...current, username: event.target.value }))}
                type="text"
                value={loginForm.username}
              />
            </label>
            <label className="grid gap-2">
              <span className="text-sm font-semibold text-[#355046]">Passord</span>
              <input
                className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
                onChange={(event) => setLoginForm((current) => ({ ...current, password: event.target.value }))}
                type="password"
                value={loginForm.password}
              />
            </label>
            {loginError ? <p className="m-0 text-sm text-[#8a2e20]">{loginError}</p> : null}
            <button className="inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-6 font-semibold text-[#f9f5ee]" type="submit">
              Logg inn
            </button>
          </form>
        </section>
      </main>
    </div>
  );
}

export default AdminLoginSection;